import { SectionHeaderLayoutProps } from "./types";
const SectionHeaderLayout = ({ children, header = null }: SectionHeaderLayoutProps) => {
  return (
    <div className={`flex flex-col py-[12px] px-[16px] text-[20px] text-black gap-[12px] font-medium max-sm:text-[18px]`}>
      {header && <h2>{header}</h2>}
      {children}
    </div>
  );
};

export default SectionHeaderLayout;